import type { MeltActionReturn } from '@melt-ui/svelte/internal/types';

export type MeltWithAction = {
    action: (node: HTMLElement) => MeltActionReturn<keyof HTMLElementEventMap>;
};

export const meltWithActionDefault: MeltWithAction = {
    action: () => {
        return {};
    },
};
